var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('abstractTable',{key:_vm.tableKeyCounter,attrs:{"columns":_vm.medicalMachinesColumns,"classes":'ui tablet very compact center aligned celled table',"paginationEnable":false,"data":_vm.computedMedicalMachines()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6074d64f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rooms/room_components/MedicalMachines.vue
// module id = null
// module chunks = 